import { Fieldset } from '@calendly/form/parts'
import { I18n } from '@calendly/i18n'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { RadioField } from '@calendly/ui/form/radio-field'
import { useState } from 'react'


import {
  BOOKING_WHEN_INVITEE_BOOKED,
  BOOKING_WHEN_MEETING_SCHEDULED
} from './consts'
import {
  GroupBlock,
  TimingOptionsBlock,
  WhenBlock,
  WhenRow
} from './styles'
import { SubTitle } from '../../../styles'


function WhenGroup({ onChange, triggerType }) {
  const defaultChecked = triggerType === BOOKING_WHEN_INVITEE_BOOKED

  return (
    <WhenBlock>
      <WhenRow>
        <RadioField
          checked={defaultChecked}
          onChange={() => { onChange(BOOKING_WHEN_INVITEE_BOOKED) }}
          label={I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.group.each_invitee')}
        />
      </WhenRow>
      <WhenRow>
        <RadioField
          checked={!defaultChecked}
          onChange={() => { onChange(BOOKING_WHEN_MEETING_SCHEDULED) }}
          label={I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.group.only_first')}
        />
      </WhenRow>
    </WhenBlock>
  )
}

function GroupToggle({ opened, onClick }) {
  const toggleCopy = opened
    ? I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.group.hide_options')
    : I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.group.show_options')
  return (
    <MinimalButton fontSize="medium" aria-expanded={opened} onClick={onClick}>
      {toggleCopy}
    </MinimalButton>
  )
}

export const GroupTriggers = (props) => {
  const { triggerType } = props
  const [opened, setOpened] = useState(false)
  const toggle = () => setOpened((prevValue) => !prevValue)
  const validTypes = [BOOKING_WHEN_INVITEE_BOOKED, BOOKING_WHEN_MEETING_SCHEDULED]

  if (!validTypes.includes(triggerType)) { return null }

  return (
    <>
      {opened && (
        <GroupBlock>
          <Fieldset>
            <SubTitle as="legend">
              {I18n.t('publisher.workflows.triggers.booking.when.invitee_booked.group.subtitle')}
            </SubTitle>
            <TimingOptionsBlock>
              <WhenGroup {...props} />
            </TimingOptionsBlock>
          </Fieldset>
        </GroupBlock>
      )}
      <GroupToggle opened={opened} onClick={toggle} />
    </>
  )
}
